{
	"ariaImportProjectFromOpfs": "Import Project From OPFS",
	"ariaImportProjectFromZip": "Import Project From Zip",
	"ariaSelectProjectFolder": "Select Project Folder",
	"ariaViewSupportedFileFormats": "View Supported File Formats",
	"cannotAddIndividualPhotos": "You cannot add individual photos.",
	"description": "Choose a folder with the photos you'd like to edit. A catalog file will be created in the same folder to keep track of your edits.",
	"dropFolderHere": "Drop a folder here",
	"importZipFile": "Import ZIP file",
	"selectFolder": "Select Folder",
	"title": "Create New Project",
	"useOpfsEntry": "Use OPFS Entry",
	"viewSupportedFormats": "View supported formats"
}
